module.exports = __webpack_public_path__ + "img/nwszj.df79560d.jpg";